// Module
var code = "<frame-custom-box [showHeader]=\"!!title\"> <frame-custom-title> <span [custom-label]=\"title\"></span> </frame-custom-title> <frame-custom-content> <ng-content></ng-content> </frame-custom-content> </frame-custom-box>";
// Exports
module.exports = code;